import { DsoManagersSource, RamUsersSource } from '../../enums/ManagerListSource';
import {
  getShouldSourceDsoManagersFromAuthService,
  getShouldSourceRamsFromSalesMetros,
} from '../../posthog';
import { MANAGER_LIST_SOURCES_RESOLVED } from '../actionTypes';

/**
 * Answers which source fills each manager list, deciding once per session.
 *
 * The first caller reads the two migration flags and records the answer in
 * `state.users.managerListSources`. Every later caller, and the office profile
 * deciding whether its RAM field is read-only, reads that record instead of the
 * flags. So a PostHog flag reload mid-session (identify triggers one) cannot
 * leave two fetchers, or a fetcher and the profile, acting on different answers.
 *
 * @returns {{ ramUsers: RamUsersSource, dsoManagers: DsoManagersSource }}
 */
export const ensureManagerListSources = () => (dispatch, getState) => {
  const recorded = getState().users?.managerListSources;
  if (recorded) {
    return recorded;
  }

  const sources = {
    ramUsers: getShouldSourceRamsFromSalesMetros()
      ? RamUsersSource.SalesMetros
      : RamUsersSource.Monolith,
    dsoManagers: getShouldSourceDsoManagersFromAuthService()
      ? DsoManagersSource.AuthService
      : DsoManagersSource.Monolith,
  };
  dispatch({ type: MANAGER_LIST_SOURCES_RESOLVED, payload: sources });

  return sources;
};
